module.exports = __webpack_public_path__ + "img/media-13.1e8fc83c.png";